
import { Component, Prop, Vue } from 'vue-property-decorator'

@Component({ name: 'Subtitle' })
export default class extends Vue {
  @Prop()
  event: EventWithMeta

  get subtitle() {
    return this.event?.subtitle
  }
}
